<div class="modal-header position-relative justify-content-center">
    <h3 class="modal-title fw-semi-bold">Subscribe</h3>
    <pp-button class="position-absolute end-0 pe-7"
        ariaLabel="Close"
        id="setupBillingModalClose"
        [shape]="buttonShape.Square"
        [variant]="buttonVariant.Transparent"
        (buttonClick)="activeModal.dismiss()">
        <img alt="Close" class="no-padding btn-close m-0 p-1" [src]="resolveImageIcon('cancel')" />
    </pp-button>
</div>
<div class="modal-body flex-fill h-100">
    <div id="paymentSubscriptionSelection" class="payment-subscription-select h-100">
        <div id="paymentSubscriptionSelectionWebView" [@heightAnimation]="{ value: stripPricingTableHeight > 0 ? 'expanded' : 'collapsed', params: { height: stripPricingTableHeight } }">
            <pp-embedded-billing-web-view />
        </div>
    </div>
</div>
